import React, {Component} from 'react'
import {Button} from "reactstrap"
import ImportModal from "./ImportModal"

class Import extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const {isOpen} = this.state

        return (
            <div className="Import">
                <Button color='secondary ml-3' onClick={this._handleToggleModal}>
                    Import
                </Button>
                {isOpen && (
                    <ImportModal
                        isOpen={isOpen}
                        onToggleModal={this._handleToggleModal}
                        {...this.props}
                    />
                )}
            </div>
        )
    }

}

export default Import